import { render } from "./NameTag.vue?vue&type=template&id=e37b6232&scoped=true&ts=true"
import script from "./NameTag.vue?vue&type=script&lang=ts"
export * from "./NameTag.vue?vue&type=script&lang=ts"

import "./NameTag.vue?vue&type=style&index=0&id=e37b6232&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37b6232"]])

export default __exports__